import { render, staticRenderFns } from "./basic-picker.mpx?vue&type=template&id=682b34f0&isComponent&outputPath=components%2Fbasic-picker9b69181c%2Findex"
import script from "./basic-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbasic-picker9b69181c%2Findex"
export * from "./basic-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbasic-picker9b69181c%2Findex"
import style0 from "./basic-picker.mpx?vue&type=style&index=0&id=682b34f0&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_9b69181c%22%7D&isComponent&outputPath=components%2Fbasic-picker9b69181c%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports